/**
 * Created by caterina on 04-05-17.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../_shared/guards/authentication-guard';
import {ProjectComponent} from './project-view/project-view.component';

const projectRoutes: Routes = [
    {path: 'proyecto/:id', component: ProjectComponent, canActivate: [AuthGuard]},
    {path: 'crear-proyecto', component: ProjectComponent, canActivate: [AuthGuard]},
];


@NgModule({
    imports: [
        RouterModule.forChild(projectRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class ProjectRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/project/project-routing.module.ts